import React from 'react';
import AttachBusinessCardToggle from '../../../components/businessCard/AttachBusinessCardToggle.jsx';

/**
 * Card link name (/c/{slug}) + the "attach to first-touch texts" switch.
 * @param {{form: {cardSlug: string, attachDigitalBusinessCard: boolean}, setForm: Function, origin: string}} props
 * @returns {JSX.Element}
 */
export default function CardLinkSection({ form, setForm, origin }) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-4 space-y-4">
      <div>
        <label htmlFor="card-slug" className="block text-xs font-semibold text-white/70 mb-1">Your card link</label>
        <div className="flex items-center rounded-lg border border-white/10 bg-black/30 overflow-hidden">
          <span className="px-3 text-xs text-white/40 whitespace-nowrap">{origin.replace(/^https?:\/\//, '')}/c/</span>
          <input
            id="card-slug"
            value={form.cardSlug}
            onChange={(e) => setForm((f) => ({ ...f, cardSlug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-') }))}
            placeholder="your-name"
            maxLength={40}
            className="flex-1 bg-transparent py-2 pr-3 text-sm text-white focus:outline-hidden"
          />
        </div>
        <p className="text-[11px] text-white/40 mt-1">3-40 letters, numbers or dashes. Links already shared keep working.</p>
      </div>
      <AttachBusinessCardToggle
        id="card-attach-default"
        checked={form.attachDigitalBusinessCard}
        onChange={(v) => setForm((f) => ({ ...f, attachDigitalBusinessCard: v }))}
      />
    </div>
  );
}
